<template>
        <svg version="1.1" id="exam-previous-icon" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px" viewBox="0 0 191.1 337" style="enable-background:new 0 0 191.1 337;" xml:space="preserve">
<path d="M191.1,22.7v291.6c0,20.2-24.4,30.3-38.7,16L6.6,184.5c-8.8-8.8-8.8-23.2,0-32L152.4,6.7C166.7-7.6,191.1,2.5,191.1,22.7z"
/>
</svg>
</template>

<script>
    export default {
        name: "PrevIcon"
    }
</script>

<style scoped>

</style>
